//import Cookies from 'js-cookie';
import {modal} from "../UI/modal";
import Agent from "../Core/agent";
import {parseHTML} from "../Core/common";
import {URL2GET} from "../Url";

const printContacts = (item, data) => {
    item.innerHTML = '';

    if (item.dataset.type && item.dataset.type === 'full') {
        data.forEach(tmp => {
            let phones = tmp.phones.map(phone => `<a class="fw-regular mb-10" href="tel:+${phone[0]}">${phone[1]}</a>`);
            let emails = tmp.emails.map(email => `<a class="fw-regular" href="mailto:${email}">${email}</a>`);

            item.append(parseHTML(`<div class="d-flex flex-column mb-20">
                                            <span class="d-inline-block mb-10">${tmp.locality}, ${tmp.street}, ${tmp.house}</span>
                                            ${phones.join('')}
                                            ${emails.join('')}
                                        </div>`));
        });
    } else {
        let html = '';
        data.forEach(tmp => {
            html += `<div class="lh-base fs-14 mb-5">${tmp.street}, ${tmp.house}</div>`;
        });

        item.innerHTML = html;
    }
    const parent = item.parentElement;
    if (parent.classList.contains('spoiler-block')) {
        parent.style.height = item.clientHeight + 'px';
    }
};

const defaultLocality = 2;


const setCity = city => {
    let citiname = city && city.trim().length ? city : 'Выберите ваш город';
    if (["deartfloor.ru", "deart.loc"].indexOf(document.location.hostname) >= 0) {
        localStorage.setItem('city', citiname);
        document.querySelectorAll('.geo_location1').forEach(item => {
            item.innerHTML = citiname;
            item.classList.remove('preloader');
        });
    }
};

const modalConfig = {
    'size': 'modal-dialog modal-dialog-centered',
    'title': '',
    'message': '',
    'footer': '',
    'header': function () {
        return `<div class="modal-header">
           
                <button class="btn-close position-absolute end-0 top-0 border-0 ms-auto d-flex bg-transparent" data-bs-dismiss="modal"><i class="icon close"></i></button>
                <hr>
            </div>`;
    },
    'closeBtm': ``,
    showEvent: function (el, modal) {
        const citySelect = el.querySelector('input[name="city-select"]');
        citySelect.closest('form').addEventListener('submit', event => {
            event.preventDefault();
            event.stopPropagation();
        })

        const js_clear_select_city_input = el.querySelector('.js_clear_select_city_input');
        const js_map_cities_block = el.querySelector('.js_map_cities_block');
        let cities = new Map();
        let initItem = (item) => {
            let cityName = item.querySelector('.city_option').innerHTML;
            cities.set(cityName.toUpperCase().trim(), item);

            item.addEventListener('click', event => {
                event.stopPropagation();
                event.preventDefault();

                let a = item.querySelector('a');

                let params = new URLSearchParams(a.search);
                //params.set('set_city', cityName);
                a.search = params.toString();
                document.location.href = a.href;
            });
        };

        js_map_cities_block.querySelectorAll('.js_city_element').forEach(item => initItem(item));

        let searchCity = function () {
            const currentValue = citySelect.value.toUpperCase();
            let filteredItems = new Map();
            let isFounded = false;

            cities.forEach((item, value) => {

                item.classList.add('d-none');

                let city = value.toUpperCase().trim();
                if (currentValue.length) {
                    if (city.indexOf(currentValue) === 0) {
                        isFounded = true;
                        filteredItems.set(item, item);
                    }
                } else {
                    filteredItems.set(item, item);
                }
            });

            filteredItems.forEach(item => item.classList.remove('d-none'));

            if (isFounded === false) {
                js_clear_select_city_input.classList.add('preloader');
                Agent.post(
                    '/api/v1/locality/city/search/',
                    JSON.stringify({"address": currentValue}),
                    {
                        headers: {
                            'Content-Type': 'application/json;'
                        }
                    })
                    .then(e => e.json())
                    .then(response => {
                        if (response.success) {
                            response.data.forEach(data => {
                                if (!cities.has(data.title.toUpperCase().trim())) {
                                    let newItem = parseHTML(` <li class="js_city_element js_map_cities_new">
                                                            <a class="modal-city__item d-flex gap-5 fs-lg-16 fs-14"
                                                               href="#"
                                                               title="Выбрать ${data.title}"
                                                            >
                                                                <i class="icon location fs-18"></i>
                                                                <span class="city_option">${data.title}</span>
                                                            </a>
                                                        </li>`);

                                    js_map_cities_block.append(newItem);

                                    js_map_cities_block.querySelectorAll('.js_map_cities_new').forEach(el => {
                                        el.classList.remove('js_map_cities_new');
                                        initItem(el);
                                    });
                                }
                            });
                        }
                    }).catch(e => {
                    console.log(e);
                })
                    .finally(() => {
                        js_clear_select_city_input.classList.remove('preloader');
                    });
            }
        };

        js_clear_select_city_input.addEventListener('click', () => {
            citySelect.value = '';
            searchCity();
        });

        let inputTimer;
        citySelect.addEventListener('input', () => {
            clearTimeout(inputTimer);
            inputTimer = setTimeout(searchCity, 500);
        });

        // el.querySelectorAll('a').forEach(item => item.addEventListener('click', event => {
        //     event.stopPropagation();
        //     event.preventDefault();
        //     setCity(item.querySelector('.city_option').innerHTML);
        //     modal.hide();
        // }));
    },
};

export default class Locations {
    constructor(events) {
        this.events = events;
        this.cache = new Map();

        this.state = {modal: null, pending: false};
        //this.setCity(localStorage.getItem('city'), localStorage.getItem('city_id'));
       // setCity(localStorage.getItem('city'));
        //this.getPhoneRegion();
        this.dialog = null;

    }


    // setCity(city, city_id) {
    //     if (city && city.trim().length && city_id) {
    //         localStorage.setItem('city', city);
    //         localStorage.setItem('city_id', city_id);
    //         document.querySelectorAll('.geo_location1').forEach(item => {
    //             item.innerHTML = city;
    //         });
    //         Cookies.set('user_city_name', 1, {sameSite: 'strict'});
    //         Cookies.set('user_city', city_id, {sameSite: 'strict'});
    //         return true;
    //     }
    //
    //     return false;
    // }

    initCitySelect(modal, element) {
        element.stopPropagation();
        element.preventDefault();
        let city = element.currentTarget;

        if (this.setCity(city.dataset.name, city.dataset.id)) {
            document.querySelectorAll('.geo_location_1').forEach(cityComponent => {
                cityComponent.innerHTML = city.innerHTML;
            });

            modal.hide();
            this.getPhoneRegion();
        }

    }

    openModal(body) {
        // let initCitySelect = this.initCitySelect.bind(this);

        modal(body);
        // modal(body, (form, modal) => {
        //     const currentCityId = localStorage.getItem('city_id');
        //     document.querySelectorAll('.city_option').forEach(city => {
        //         if (+city.dataset.id === +currentCityId) {
        //             city.classList.add('active');
        //         } else {
        //             city.classList.remove('active');
        //         }
        //
        //         city.addEventListener('click', initCitySelect.bind(this, modal));
        //     });
        // }, (form, modal) => {
        //     document.querySelectorAll('.city_option').forEach(city => {
        //         city.removeEventListener('click', initCitySelect.bind(this, modal));
        //     });
        // });
    }

    getLocations(item) {
        let $this = this;
        let openModal = $this.openModal.bind(this);
        let user_city = '';
        if (localStorage.getItem('city_id')) {
            user_city = localStorage.getItem('city_id');
        }

        if ($this.state.modal !== null) {
            modalConfig.message = $this.state.modal;
            openModal(modalConfig);
        } else {
            item.classList.add('preloader');

            const formData = new FormData();
            formData.append('user_city', user_city);
            formData.append('url', window.location.href);

            Agent.post(`/api/v1/locality/open-form`, formData)
                .then(e => e.json())
                .then(e => {
                    if (e.success) {
                        $this.state.modal = e.data;

                        modalConfig.message = $this.state.modal;
                        openModal(modalConfig);
                    }
                })
                .catch(e => console.log(e))
                .finally(() => {
                    item.classList.remove('preloader');
                });
        }
    }

    getPhoneRegion() {
        const $this = this;
        document.querySelectorAll('.js_load_address_block').forEach(item => {
            if ($this.cache.has(localStorage.getItem('city_id') || defaultLocality)) {
                printContacts(item, $this.cache.get(localStorage.getItem('city_id') || defaultLocality));
            } else {
                let observer = new IntersectionObserver((entries, obs) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (!$this.cache.has(localStorage.getItem('city_id') || defaultLocality)) {
                                if (!$this.state.pending) {
                                    $this.state.pending = true;
                                    item.classList.add('preloader');
                                    Agent.post(`/api/v1/location/contacts/${localStorage.getItem('city_id') || defaultLocality}`)
                                        .then(e => e.json())
                                        .then(e => {
                                            if (e.success) {
                                                $this.cache.set(localStorage.getItem('city_id') || defaultLocality, e.data);
                                            }
                                        })
                                        .catch(e => console.log(e))
                                        .finally(() => {
                                            obs.unobserve(entry.target);
                                            item.classList.remove('preloader');
                                            $this.state.pending = false;
                                            $this.getPhoneRegion();
                                        });
                                }
                            } else {
                                obs.unobserve(entry.target);
                            }
                        }
                    });
                });
                observer.observe(item);
            }
        });
    }
}

export const init = events => new Locations(events);